export const OFFER_WALL_ACTION_PERSIST = "OFFER_WALL_PERSIST";
export const OFFER_WALL_ACTION_CLEAR = "OFFER_WALL_CLEAR";
